export default {
  PURPLE: 'purple',
};
